var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmIcnAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-671 -163) translate(251 163) translate(420) translate(1 3.429)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.29 1.846L.82 15.88c-.355.61-.357 1.363-.006 1.975.352.613 1.005.994 1.716 1.002h16.94c.71-.008 1.364-.389 1.716-1.002.351-.612.35-1.365-.006-1.975L12.71 1.846C12.347 1.253 11.7.891 11 .891s-1.347.362-1.71.955zM11 6.947L11 10.917"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 14.887,
    r: 1,
    fill: "#000"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmIcnAlertTriangle);
export default __webpack_public_path__ + "static/media/atm-icn-alert-triangle.360d6c0b245c8fc4a2122edeaf1e1fde.svg";
export { ForwardRef as ReactComponent };